import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormsModule } from '@angular/forms';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { CommandClickEventArgs, CommandModel, GridModule } from '@syncfusion/ej2-angular-grids';
import { DataManager } from '@syncfusion/ej2-data';
import { DynamicGridBaseComponent } from 'src/app/base/shared/grid-base/dynamic-grid-base.component';
import { AvpCustomAdaptor } from 'src/app/base/shared/syncfusion/avp-custom-adaptor';
import { SpinnerService } from 'src/app/base/spinner/spinner.service';
import { EnumFilterService } from 'src/app/base/services/enum-filter.service';
import { SfCommandButtonType } from 'src/app/base/models/syncfusion-data';
import { StatisticEventDTO } from 'src/app/base/models/models.swagger.generated';
import { StatisticEventsService } from './statistic-events.service';
import { statisticEventsDynamicDefinition } from './statistic-events-dynamic.definition';
import { StatisticEventDetailDialogComponent } from './statistic-event-detail-dialog/statistic-event-detail-dialog.component';

@Component({
  selector: 'app-statistic-events',
  templateUrl: './statistic-events.component.html',
  styleUrls: ['./statistic-events.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FormsModule, GridModule, StatisticEventDetailDialogComponent, TranslatePipe],
  providers: [StatisticEventsService],
})
export class StatisticEventsComponent extends DynamicGridBaseComponent<typeof statisticEventsDynamicDefinition> implements OnInit {

  public vehicleId: number | null = 1;
  public selectedEvent: StatisticEventDTO | null = null;
  public showDetailDialog = false;

  constructor(
    private statisticEventsService: StatisticEventsService,
    fb: FormBuilder,
    translateService: TranslateService,
    private spinnerService: SpinnerService,
    enumFilterService: EnumFilterService,
  ) {
    super(statisticEventsDynamicDefinition, fb, null, translateService, statisticEventsService, enumFilterService);
  }

  public ngOnInit(): void {
    this.statisticEventsService.vehicleId = this.vehicleId;
    this.data = new DataManager({
      adaptor: new AvpCustomAdaptor(this.statisticEventsService, this.spinnerService, true),
    });
    this.editSettings = {
      allowAdding: false,
      allowEditing: false,
      allowDeleting: false,
      mode: 'Dialog',
      showDeleteConfirmDialog: false,
    };
    this.gridCommands = [{
      type: 'None',
      title: this.translateService.instant('i18n.domain.analytics.statistic-events.view-details'),
      buttonOption: {
        cssClass: 'icon-btn',
        iconCss: 'icon-view e-icons',
      },
    } as CommandModel];
  }

  public onLoadEvents(): void {
    this.statisticEventsService.vehicleId = this.vehicleId;
    this.grid?.refresh();
  }

  public commandClick(args: CommandClickEventArgs): void {
    if (args.commandColumn?.type === SfCommandButtonType.None) {
      this.selectedEvent = args.rowData as StatisticEventDTO;
      this.showDetailDialog = true;
    }
  }

  protected getEditDialogTitleParams(): object {
    return {};
  }
}
